import React, { Component } from "react";
import { formatDateToPortugueseFormatWithTime, fidelityHasAverage } from "../../../shared/utils";
import { withGetScreen } from "react-getscreen";
import { SCREEN_BREAKPOINT } from "../../../shared/screen-breakpoints";
import MyPassengersLogListItem from "./MyPassengersLogListItem";

class MyPassengersLogList extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const lastLog = this.props.logs[this.props.logs.length - 1];
		const createMomentLog =
			lastLog.price === null && lastLog.miles === null ? this.props.logs.pop() : null;
		return (
			<div className="my-passengers-log-list">
				{this.props.logs.map((log, index) => (
					<MyPassengersLogListItem
						key={index}
						log={log}
						showAverageMiles={fidelityHasAverage(this.props.fidelityPlan) && !log.hadAvergeChange}
						headerDescription={`(alterado em ${formatDateToPortugueseFormatWithTime(
							log.entryDate
						)})`}
					/>
				))}
				{createMomentLog && (
					<MyPassengersLogListItem
						headerDescription={`Você criou a oferta em ${formatDateToPortugueseFormatWithTime(
							createMomentLog.entryDate
						)}`}
						headerIconClassName="icon-exclamation"
						showAverageMiles={false}
						log={createMomentLog}
						headerDescriptionSmall={false}
					/>
				)}
			</div>
		);
	}
}

export default withGetScreen(MyPassengersLogList, {
	mobileLimit: SCREEN_BREAKPOINT.sm,
	tabletLimit: SCREEN_BREAKPOINT.lg,
	shouldListenOnResize: true
});
